import type { FunctionComponent } from 'react';
import type { TypeOrderTableLineProps } from './types';

/**
 * OrderTableLine
 */
export const OrderTableLine: FunctionComponent<TypeOrderTableLineProps> = ({
  className = '',
  children,
}: TypeOrderTableLineProps) => (
  <tr className={`border border-primary-200 bg-bg-secondary p-4 ${className}`}>
    {children}
  </tr>
);
